// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import SearchPage from '@/pages/search';
// ----------------------------------------------------------------

/**
 * The Route component is a file route that is used to render the SearchPage component.
 * This is a route setup for '/search/' route.
 */
export const Route = createFileRoute('/_authenticated-layout/search/')({
  component: SearchPage,
}); 
